import { merge } from 'lodash';

// Types
import Nullable from '@/types/nullable';
import Locale from '@/types/locale';

// Utils
import { performanceTooltipFormatter } from './tooltip';
import { getThinDashedLineCrosshair } from '../../utils/crosshair';
import { getSharedTooltip } from '../../utils/tooltip';
import { formatNumber } from '@/utils/i18n';
import { LABEL_FORMATTERS } from '@/utils/charts';

export const getGrowthChartOptions = (
  options: { height: Nullable<number> | undefined; locale: Locale; animate: boolean },
  overrides: Record<string, any> = {},
) => {
  const { height, locale, animate } = options;
  const baseOptions = {
    series: {} as any,
    rangeSelector: { enabled: false },
    scrollbar: { enabled: false },
    navigator: { enabled: false },
    credits: { enabled: false },
    legend: { enabled: false },
    chart: {
      height,
      spacingLeft: 0,
      spacingRight: 0,
      panning: { enabled: true },
    },
    title: {
      text: undefined,
    },
    tooltip: getSharedTooltip(performanceTooltipFormatter),
    xAxis: {
      crosshair: getThinDashedLineCrosshair(),
      minTickInterval: 2735696401, // 1 month in milliseconds
      tickWidth: 0,
      lineWidth: 0,
      labels: {
        formatter: LABEL_FORMATTERS.date[locale].formatter,
      },
    },
    yAxis: {
      title: {
        text: null,
      },
      labels: {
        x: -5,
        y: -8,
        formatter() {
          return formatNumber(this.value);
        },
      },
      startOnTick: true,
    },
    plotOptions: {
      line: {
        marker: {
          symbol: 'circle',
          radius: 0,
          states: {
            hover: {
              lineWidth: 3,
              radius: 5,
            },
            inactive: {
              opacity: 0,
            },
          },
        },
      },
      series: {
        animation: animate,
      },
    },
  };
  return merge({}, baseOptions, overrides);
};
